module.exports = __webpack_public_path__ + "img/rank-11.521938c.svg";